import styled, { css } from "styled-components";
import { COLOURS } from "../../variables/Colors";
import { BREAKPOINTS, desktop, mobile } from "../../variables/Breakpoints";
import { setFlex } from "../../variables/Position";

const setSize = size => {
  switch (size) {
    case "small":
      return css`
        padding: 0.8rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          padding: 0.5rem;
        }
      `;
    case "medium":
      return css`
        padding: 2rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          padding: 1rem;
        }
      `;
    case "large":
      return css`
        padding: 3rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          padding: 2rem;
        }
      `;
    case "xlarge":
      return css`
        padding: 4.5rem;
      `;
    default:
      return css`
        padding: 1rem;
      `;
  }
};

export const LandingWrapper = styled.div`
  background-color: ${COLOURS.primary.black};
  min-height: 100vh;
`;

export const Container = styled.div`
  padding: 2rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 1.2rem;
  }
  ${props =>
    props.$noPadding &&
    `
  padding-top: 0;
    @media (max-width: ${BREAKPOINTS.md}px) {
      padding: 0 1.2rem 1.2rem 1.2rem;
    }
  `};
`;

export const Break = styled.div`
  ${props => setSize(props.$size)};
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
`;

export const HeaderWrapper = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  background-color: ${COLOURS.primary.black};
  padding: 4rem;
  ${desktop};
`;

export const CreditsContainer = styled.div`
  ${props =>
    setFlex({
      justify: props.$justify || "center",
      align: props.$align,
      direction: props.$direction,
    })};
  width: 80%;
  margin: 0 auto;
  padding: 1.5rem 0;
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ direction: "column" })};
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
  }
  ${props => props.$noPadding && "padding-top: 0"};
`;

export const Column = styled.div`
  ${props =>
    setFlex({
      justify: props.$justify,
      align: props.$align,
      direction: props.$direction,
    })};
  flex-grow: 1;
  max-width: ${props => (props.$noWidth ? "unset" : "50%")};
  ${props =>
    props.$direction !== "row" &&
    `
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ direction: "column" })};
  }
  `};
  @media (max-width: ${BREAKPOINTS.md}px) {
    max-width: 100%;
  }
`;

export const FooterColumn = styled(Column)`
  ${props => props.$noGrow && "flex-grow: unset"};
  ${props => props.$noWidth && "max-width: unset"};
  ${props => props.$desktop && desktop};
  margin-bottom: 0.5rem;
`;

export const FooterCreditsContainer = styled.div`
  ${setFlex({ justify: "center" })};
`;

export const Border = styled.div`
  ${setFlex({})};
  flex-grow: 1;
  border-bottom: 1px dashed ${COLOURS.primary.pink};
  margin: 0 0.5rem 0.25rem 0.5rem;
`;
